import { FormCloudEnvironment, GlobalResponse } from '~/models/Commons ';
import { api } from '../api';
import { CLOULD_ENVIRONMENTS} from '../endpoints';
import { SET_CLOUDENVIRONMENT } from '~/store/feature/CloudEnvironment';

const extendedApiSlice = api.injectEndpoints({
  endpoints: builder => ({
    getCloudEnvironments: builder.query<
      GlobalResponse<any[]>,
      { page: number; size: number; active: boolean }
    >({
      query: ({ page, size, active }) => ({
        url: `${CLOULD_ENVIRONMENTS}?page=${page}&size=${size}&active=${active}`,
        method: 'GET',
        credentials: 'include',
        headers: {
          Authorization: sessionStorage.getItem('access_token')
            ? `Bearer ${sessionStorage.getItem('access_token')}`
            : ``,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(SET_CLOUDENVIRONMENT(data.payload));
        } catch (error) {
          console.error('Error fetching scripts:', error);
        }
      },
    }),
    saveCloudEnvironment: builder.mutation<GlobalResponse<FormCloudEnvironment>, FormCloudEnvironment>({
      query: (data) => {
        const token = sessionStorage.getItem('access_token');
        if (!token) {
          throw new Error('No access token found');
        }
    
        return {
          url: CLOULD_ENVIRONMENTS, 
          method: 'POST',
          body: data,
          credentials: 'include',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        };
      },
    }),
      updateCloudEnvironment: builder.mutation<GlobalResponse<FormCloudEnvironment>, { id: number; data: FormCloudEnvironment }>(
        {
          query: ({ id, data }) => ({
            url: `${CLOULD_ENVIRONMENTS}/${id}`,
            method: 'PUT',
            body: data,
            formData: true,
            credentials: 'include',
            headers: {
              Authorization: sessionStorage.getItem('access_token')
                ? `Bearer ${sessionStorage.getItem('access_token')}`
                : '',
            },
          }),
        }
      ),
      
    deleteCloudEnvironments: builder.mutation<GlobalResponse<FormCloudEnvironment>, number>({
      query: cloudEnvironmentId => ({
        url: `${CLOULD_ENVIRONMENTS}/${cloudEnvironmentId}`,
        method: 'DELETE',
        credentials: 'include',
        headers: {
          Authorization: sessionStorage.getItem('access_token')
            ? `Bearer ${sessionStorage.getItem('access_token')}`
            : '',
        },
      }),
    }),
  }),
});

export const {
  useSaveCloudEnvironmentMutation,
  useUpdateCloudEnvironmentMutation,
  useGetCloudEnvironmentsQuery,
  useLazyGetCloudEnvironmentsQuery,
  useDeleteCloudEnvironmentsMutation,
} = extendedApiSlice;